import { Component } from '@angular/core';
import { AnnotationFactory } from '@features/labeling/services/annotation.factory';
import { LabelingService } from '@features/labeling/services/labeling.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LabelingTask } from 'src/generated-sources';
import { LabelingReviewAnnotationGroupService } from '../../services/labeling-review-annotation-group.service';

@UntilDestroy()
@Component({
    selector: 'annotation-group-list',
    templateUrl: './annotation-group-list.component.html',
    styleUrls: [
        '../../../shared-styles/annotation.less',
        './annotation-group-list.component.less'
    ]
})
export class AnnotationGroupListComponent {
    hasSelectedAnnotationGroup$: Observable<boolean>;
    readonly LabelingTaskType = LabelingTask.LabelingTaskType;

    constructor(
        private annotationFactory: AnnotationFactory,
        public labelingReviewAnnotationGroupService: LabelingReviewAnnotationGroupService,
        public labelingService: LabelingService,
    ) {
        this.hasSelectedAnnotationGroup$ = labelingReviewAnnotationGroupService.annotationGroupList$.pipe(
            map(annotationGroupList => annotationGroupList.some(r => r.selected))
        )
    }

    selectAnnotationGroup(index: number) {
        this.labelingReviewAnnotationGroupService.selectAnnotationGroup(index);
    }

    deleteAnnotationGroup(type: LabelingTask.LabelingTaskType, index: number) {
        switch (type) {
            case LabelingTask.LabelingTaskType.IMAGE_CLASSIFICATION:
                // clear out all objects
                this.labelingReviewAnnotationGroupService.updateAnnotationGroup([this.annotationFactory.createEmptyAnnotation()], true);
                break;
            default:
                this.labelingReviewAnnotationGroupService.deleteAnnotationGroup(index);
        }
    }

    getDeleteTooltip(type: LabelingTask.LabelingTaskType) {
        switch (type) {
            case LabelingTask.LabelingTaskType.IMAGE_CLASSIFICATION:
                return 'Clear all annotations for this image'
            default:
                return 'Delete region'
        }
    }
}


